import { render, staticRenderFns } from "./Profiel.vue?vue&type=template&id=51d613ca&scoped=true"
import script from "./Profiel.vue?vue&type=script&lang=js"
export * from "./Profiel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d613ca",
  null
  
)

export default component.exports